/* unplugin-vue-components disabled */import { render } from "./DeviceOnei.vue?vue&type=template&id=bfdc8080&scoped=true"
import script from "./DeviceOnei.vue?vue&type=script&lang=js"
export * from "./DeviceOnei.vue?vue&type=script&lang=js"

import "./DeviceOnei.vue?vue&type=style&index=0&id=bfdc8080&scoped=true&lang=css"

import exportComponent from "/Users/rabbuse/Project/Vue/txgy-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bfdc8080"]])

export default __exports__